import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './OtherTest.module.less';
import { CONTEXT } from '../../config';
import { useHistory } from 'react-router-dom';

export default function Shop() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [value, setValue] = useState(
    `https://pcstore-fe-test.lenovomm.cn/popup/html/test/test.html?t=${Math.random()}` ||
      'https://www.lenovomm.com/',
  );

  useEffect(() => {}, []);
  const handleChange = useCallback(ev => {
    const inputValue = ev.target.value;
    setValue(inputValue);
  });

  const handlebtn = useCallback(() => {
    history.push(`${CONTEXT}/otherpage?pageUrl=${value}&bizInfo=${'{}'}`);
  }, [value]);

  return (
    <>
      <div className={styles.othertest}>
        <input className={styles.othertest_input} value={value} onChange={handleChange} />
        <div className={styles.othertest_go} onClick={handlebtn}>
          go go go{' '}
        </div>
      </div>
    </>
  );
}
